import { escapeHtml } from '@shared/utils/sanitize';

/** Indicateur d’étapes activation Cloud (1 = clé, 2 = administrateur). */
export function webActivationStepHtml(current: 1 | 2): string {
  return `
    <nav class="login-step-indicator" aria-label="Progression de l’activation">
      <ol>
        <li class="${current === 1 ? 'is-current' : 'is-done'}" ${current === 1 ? 'aria-current="step"' : ''}>
          <span class="login-step-num">1</span>
          <span class="login-step-label">Clé de licence</span>
        </li>
        <li class="${current === 2 ? 'is-current' : ''}" ${current === 2 ? 'aria-current="step"' : ''}>
          <span class="login-step-num">2</span>
          <span class="login-step-label">Premier administrateur</span>
        </li>
      </ol>
      <p class="login-step-status">Étape ${current} sur 2</p>
    </nav>`;
}

/** Rappel offre reconnue (tier + expiration) — jamais le nom d’entreprise avant auth. */
export function webOfferSummaryHtml(tier?: string, licenseExpiresAt?: string): string {
  if (!tier && !licenseExpiresAt) return '';
  const tierLabel = tier
    ? tier.charAt(0).toUpperCase() + tier.slice(1)
    : 'Offre reconnue';
  let expiryLine = '';
  if (licenseExpiresAt) {
    const ms = Date.parse(licenseExpiresAt);
    const dateLabel = Number.isFinite(ms)
      ? new Date(ms).toLocaleDateString('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      : licenseExpiresAt;
    expiryLine = `<p class="hint">Valable jusqu’au ${escapeHtml(dateLabel)}</p>`;
  }
  return `
    <div class="login-offer-summary" role="status">
      <p><strong>Offre reconnue :</strong> ${escapeHtml(tierLabel)}</p>
      ${expiryLine}
    </div>`;
}
